import ActionHelper from "../helpers/ActionHelper";

export const getActions = () => ActionHelper.requestServer("GET", "/action");



// WEBPACK FOOTER //
// ./src/actions/actionActions.js